export const COMMUNITY_DOMAIN = 'beta.community.eufy.com'
export const DEFAULT_APP_NAME = 'eufy security'

export const DOMAINS = {
  discourse: {
    qa: 'https://beta.community.eufy.com',
    pr: 'https://community.eufy.com',
  },
  community: {
    qa: 'https://security-app-community-qa.eufylife.com',
    pr: 'https://security-app-community.eufylife.com',
  },
  mall: {
    qa: 'https://security-mall-qa.eufylife.com',
    pr: 'https://security-mall.eufylife.com',
    eu: 'https://security-mall-eu.eufylife.com',
  },
  app: {
    US: {
      qa: 'https://security-app-qa.eufylife.com',
      pr: 'https://security-app.eufylife.com',
    },
    CN: {
      // qa: 'https://ecommerce-cms-qa.anker.com.cn',
      // pr: 'https://ecommerce-cms.anker.com.cn',
      qa: 'https://security-app-qa.eufylife.com',
      pr: 'https://security-app.eufylife.com',
    },
  } as Record<string, Record<string, string>>,
  cms: {
    US: {
      qa: 'https://ecommerce-cms-qa.eufylife.com',
      pr: 'https://ecommerce-cms.eufylife.com',
    },
    CN: {
      qa: 'https://ecommerce-cms-qa.anker.com.cn',
      pr: 'https://ecommerce-cms.anker.com.cn',
    },
  } as Record<string, Record<string, string>>,
  // start_ai_generated
  tutorial: {
    qa: 'https://security-tutorial-qa.eufylife.com',
    pr: 'https://security-tutorial.eufylife.com',
  },
  // end_ai_generated
}

export const CONTENT_TYPE: {
  [x: string]: {
    guide?: string
    document?: string
    doctype?: number
    quick?: string
    article?: string
    categoties?: string
  }
} = {
  eufy_security: {
    guide: 'sec-tutorial-guide',
    document: 'sec-tutorial-document',
    quick: 'sec-tutorial-quick-start',
    categoties: 'sec-tutorial-catagory-page',
    article: 'sec-solution-articles',
    doctype: 2,
  },
  eufy_mega: {
    guide: 'sec-tutorial-guide',
    document: 'sec-tutorial-document',
    quick: 'sec-tutorial-quick-start',
    categoties: 'sec-tutorial-catagory-page',
    article: 'sec-solution-articles',
    doctype: 2,
  },
  anker_power: {
    guide: 'anker-tutorial-guide',
    document: 'anker-tutorial-document',
    quick: 'anker-tutorial-quick-start',
    article: '',
    doctype: 4,
    categoties: 'anker-tutorial-catagory-page',
  },
  eufy_appliances: {
    guide: 'ap-tutorial-guide',
    document: 'ap-tutorial-document',
    quick: 'ap-tutorial-quick-start',
    article: 'ap-solution-articles', //AP solution
    doctype: 6,
    categoties: 'ap-tutorial-catagory-page',
  },
  nebula: {
    guide: 'sec-tutorial-guide',
    document: 'sec-tutorial-document',
    quick: 'nebula-tutorial-quick-start',
    article: '',
    doctype: 8,
    categoties: 'sec-tutorial-catagory-page',
  },
  soundcore: {
    guide: 'soundcore-tutorial-guide',
    document: 'soundcore-tutorial-document',
    quick: 'soundcore-tutorial-quick-start',
    categoties: 'soundcore-tutorial-catagory-page',
    article: 'soundcore-solution-articles',
    doctype: 10,
  },
}
